import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import css from './FeaturesScroller.module.scss';
import LazyImg from '../LazyImg';
import windowHeight from '../../utils/dom/windowHeight';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LISTENER_THRESHOLD = 0.1; // fraction of component visible required for scroll listening

var STEPS = 100; // steps to determine number of observation points

var buildThreshold = function buildThreshold(steps) {
  return Array(steps + 1).fill(0).map(function (_, index) {
    return Math.round(index / steps * 100) / 100 || 0;
  });
};

var FeaturesScroller = /*#__PURE__*/function (_PureComponent) {
  _inherits(FeaturesScroller, _PureComponent);

  var _super = _createSuper(FeaturesScroller);

  function FeaturesScroller(props) {
    var _this;

    _classCallCheck(this, FeaturesScroller);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleScrollListener", function (on) {
      _this.isListening = on;
      var method = "".concat(on ? 'add' : 'remove', "EventListener");
      window[method]('scroll', _this.onMessagesScroll, {
        passive: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onIntersect", function (entries) {
      entries.forEach(function (entry) {
        var intersectionRatio = entry.intersectionRatio;
        var inView = intersectionRatio > LISTENER_THRESHOLD;
        var shouldUpdate = inView && !_this.isListening || !inView && _this.isListening;

        if (shouldUpdate) {
          _this.toggleScrollListener(inView);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      if (!(_this.bgRef && _this.bgRef.current)) {
        return;
      }

      if (_this.messageRefs.length < 1) {
        return;
      }

      var lastMessage = _this.messageRefs[_this.messageRefs.length - 1];

      if (!lastMessage || !lastMessage.current) {
        return;
      }

      var message = lastMessage.current.querySelector(".".concat(css.messageInner));
      var bgHeight = _this.bgRef.current.offsetHeight;
      var halfScreen = windowHeight() / 2;
      var bgCeiling = halfScreen - bgHeight / 2;
      var bgFloor = halfScreen + bgHeight / 2;
      var messageHeight = message ? message.offsetHeight : 0;

      _this.setState({
        bgCeiling: bgCeiling,
        bgFloor: bgFloor,
        bgHeight: bgHeight,
        messageHeight: messageHeight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMessagesScroll", function () {
      var _this$state = _this.state,
          bgCeiling = _this$state.bgCeiling,
          bgFloor = _this$state.bgFloor,
          currentIndex = _this$state.index;

      var index = _this.messageRefs.findIndex(function (message) {
        if (!message || !message.current) {
          return false;
        }

        var content = message.current.querySelector(".".concat(css.messageInner));
        var bounds = content.getBoundingClientRect();
        var top = bounds.top,
            bottom = bounds.bottom;
        return top <= bgFloor && bottom > bgCeiling;
      });

      if (index > -1 && index !== currentIndex) {
        _this.setState({
          index: index
        });
      }
    });

    _this.state = {
      bgCeiling: 0,
      bgFloor: 0,
      bgHeight: 0,
      index: 0,
      messageHeight: 0
    };
    var features = _this.props.features;
    _this.bgRef = /*#__PURE__*/React.createRef();
    _this.messageRefs = features.map(function () {
      return /*#__PURE__*/React.createRef();
    });
    _this.rootRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(FeaturesScroller, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var threshold = buildThreshold(STEPS);
      this.onResize();
      this.observer = new IntersectionObserver(this.onIntersect, {
        threshold: threshold
      });
      this.observer.observe(this.rootRef.current);
      this.toggleScrollListener(true);
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var features = this.props.features;
      var _this$state2 = this.state,
          bgFloor = _this$state2.bgFloor,
          bgHeight = _this$state2.bgHeight,
          index = _this$state2.index,
          messageHeight = _this$state2.messageHeight;
      var screenHeight = windowHeight();
      var messageVerticalPadding = {
        paddingTop: bgHeight / 2,
        paddingBottom: bgHeight / 2
      };
      return /*#__PURE__*/_jsx("section", {
        className: css.root,
        ref: this.rootRef,
        children: /*#__PURE__*/_jsxs("ul", {
          className: css.messages,
          children: [/*#__PURE__*/_jsx("li", {
            className: css.bg,
            children: /*#__PURE__*/_jsx("div", {
              className: css.bgInner,
              ref: this.bgRef,
              children: features.map(function (_ref, fIndex) {
                var id = _ref.id,
                    image = _ref.image,
                    title = _ref.title;
                return /*#__PURE__*/_jsx("div", {
                  className: cc([css.bgImageWrap, _defineProperty({}, css.show, index >= fIndex)]),
                  children: /*#__PURE__*/_jsx(LazyImg, {
                    alt: title,
                    className: css.bgImage,
                    src: image
                  })
                }, "image-".concat(id));
              })
            })
          }), features.map(function (_ref3, fIndex) {
            var description = _ref3.description,
                id = _ref3.id,
                title = _ref3.title;

            var styling = _objectSpread({}, messageVerticalPadding);

            if (fIndex === 0) {
              styling.marginTop = bgFloor - screenHeight;
              styling.paddingTop = 0;
            }

            if (fIndex === features.length - 1) {
              styling.paddingBottom = screenHeight / 2 - messageHeight / 2;
            }

            return /*#__PURE__*/_jsx("li", {
              className: css.message,
              "feature-index": fIndex,
              ref: _this2.messageRefs[fIndex],
              style: styling,
              children: /*#__PURE__*/_jsxs("div", {
                className: css.messageInner,
                children: [/*#__PURE__*/_jsx("h2", {
                  className: css.title,
                  dangerouslySetInnerHTML: {
                    __html: title
                  }
                }), /*#__PURE__*/_jsx("p", {
                  className: css.description,
                  children: description
                })]
              })
            }, "message-".concat(id));
          })]
        })
      });
    }
  }]);

  return FeaturesScroller;
}(PureComponent);

FeaturesScroller.propTypes = {
  features: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired
};
export default FeaturesScroller;